
/**
 * 강좌 가격 정보 (무료 강좌는 null 또는 amount 0)
 * @nullable
 */
export type UpdateEnrollmentProgress200CoursePrice = {
  /** 가격 금액 */
  amount: number;
  /** 통화 코드 (ISO 4217) */
  currency: string;
} | null;
